import { useState } from 'react';
import { Switch } from '@kula-ai/components';

import { useThemePreference } from './useThemePreference';

/**
 * How long the switch's knob takes to slide (kula Switch: 200ms transform),
 * plus a beat. The page crossfade starts after it, so the switch visibly
 * flips first instead of freezing mid-slide in the transition snapshot.
 */
const SWITCH_SETTLE_MS = 220;

/** A single on/off switch for dark mode, for compact spots like menus. */
export const DarkModeSwitch = () => {
  const { resolvedTheme, setPreference } = useThemePreference();
  // The switch's own state while its knob slides, before the theme changes.
  const [pendingOn, setPendingOn] = useState<boolean | null>(null);

  const handleChange = (on: boolean) => {
    setPendingOn(on);
    window.setTimeout(() => {
      setPreference(on ? 'dark' : 'light');
      setPendingOn(null);
    }, SWITCH_SETTLE_MS);
  };

  return (
    <Switch
      size="sm"
      aria-label="Dark mode"
      checked={pendingOn ?? resolvedTheme === 'dark'}
      onCheckedChange={handleChange}
      data-test-id="dark-mode-switch"
    />
  );
};
